<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('zonesCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="zone-list-workspace">
      <app-master-table
        [title]="'zonesCatalog.title' | translate"
        [dataSource]="dataSource"
        [columnDefinitions]="columnDefinitions"
        [actions]="actions"
        [filters]="tableFilters"
        [isLoading]="isLoading"
        [enableRowClick]="false"
        [rowClickSelection]="true"
        [showContextMenu]="false"
        [tableMaxHeight]="'560px'"
        [exportFileName]="'attendance-zones'"
        [useServerData]="true"
        [totalItems]="totalItems"
        [currentPage]="currentPage"
        [searchValue]="searchValue"
        [pageSize]="pageSize"
        [pageSizeOptions]="[15, 25, 50, 100, 200]"
        (add)="handleAdd()"
        (refresh)="loadData()"
        (details)="handleView($event)"
        (edit)="handleEdit($event)"
        (delete)="handleDelete($event)"
        (bulkDelete)="handleBulkDelete($event)"
        (searchChange)="onSearchChange($event)"
        (filtersChange)="onFiltersChange($event)"
        (pageChange)="onPageChange($event)">
      </app-master-table>
    </div>
  </div>
</section>
